import styled from 'styled-components';

interface IRangeProps {
	min: number;
	max: number;
	value: number;
}

const rangeToPercent = ({ min, max, value }: IRangeProps) =>
	((value - min) * 100) / (max - min);

const StyledSlider = styled.input.attrs({ type: 'range' })`
	position: relative;
	width: 100%;
	margin: 0;
	appearance: none;
	border-radius: 6px;
	background-color: #202020;

	&::-webkit-slider-thumb {
		height: 10px;
		opacity: 0;
	}

	&::-webkit-slider-runnable-track {
		height: 6px;
		border-radius: 6px;
		background-image: linear-gradient(
			90deg,
			#1678c2 ${(props) => rangeToPercent(props as IRangeProps)}%,
			#202020 ${(props) => rangeToPercent(props as IRangeProps)}%
		);
	}

	&:focus {
		outline: none;
	}
`;

export { StyledSlider };
